module.exports = __webpack_public_path__ + "img/3.6eec036f.gif";